module.exports = __webpack_public_path__ + "img/tu09.67961418.png";